<template>
  <div>
    <CustomModalTemplate
      :modalId="modalId"
      ref="commModalRef"
      @hidden="onModalHidden" 
      :visible="isModalVisible" 
      :noCloseOnBackdrop="true"
      :noCloseOnEsc="false"
      class="communication-modal"
    >
      <template slot="header">
        <div
          class="header-communication color-green-2"
          v-if="communication"
        >
          {{ communication.greetingMessage }} <strong>{{ getUser() }}</strong>!
        </div>
      </template>
      <template slot="content">
        <div>
          <div
            :class="getClasses()"
            class="content-principal"
            @scroll="onScroll"
            v-if="communication"
          >
            <p
              class="color-green-2 font-communication-size"
              v-html="getCommunicationDescription()"
            ></p>
          </div>
          <img
            class="image-communication"
            height="250"
            v-if="communication && communication.linkImage"
            :src="communication.linkImage"
          />
        </div>
      </template>
      <template slot="footer">
        <div class="footer-div-container">
          <div class="line-footer"></div>
          <div class="footer-div-button">
            <b-button
              class="ml-4"
              variant="outline-primary"
              :disabled="buttonDisabled || !isCommunicationCurrent"
              @click="onRedirect"
              v-if="communication && getCommunicationTextLink()"
            >
              {{ getCommunicationTextLink() }}
            </b-button>
            <b-button
              class="ml-4"
              variant="primary"
              @click="onUpdate"
              v-if="communication && getCommunicationTextButton()"
            >
              {{ isCommunicationCurrent ? getCommunicationTextButton() : "Fechar" }}
            </b-button>
          </div>
        </div>
      </template>
    </CustomModalTemplate>
    <UpdatedInformations 
      v-if="showUpdatedInformations" 
      @close="onModalHidden"
    />
  </div>
</template>

<script>
import CustomModalTemplate from "../../../components/custom-modal/CustomModalTemplate.vue";
import { getNameUser } from "../../../utils/user/user";
import {
  updateCommunication,
  getCommunication,
  createCommunicationEvent,
} from "../../../services/communication/communication";
import isAbleRole from "../../../utils/permissions/is-able-role";
import { RoleList } from "../../../static-data/RoleList";
import { Firebase } from "../../../services/firebase/log-firebase";
import UpdatedInformations from "../../../modules/updatedInformations/views/UpdatedInformations.vue";
import { getShowNotification } from "../../../services/updated-informations/updated-informations-service";
import eventBus from "../../../services/event-bus/eventBus.js";

export default {
  props: ["visualization", "modalId", "forceUpdate"],
  components: {
    CustomModalTemplate,
    UpdatedInformations,
  },
  data() {
    return {
      buttonDisabled: true,
      communication: null,
      showUpdatedInformations: false,
      updateForce: false,
      isCommunicationCurrent: true,
      isModalVisible: false,
    };
  },
  watch: {
    visualization: {
      immediate: true,
      handler(newValue) {
        this.communication = newValue;
        this.checkCommunicationCurrent();
      },
    },
    forceUpdate: {
      immediate: true,
      handler(newValue) {
        this.updateForce = newValue;
      },
    },
  },
  async mounted() {
    
    this.$nextTick(async () => {
      if (this.$props.forceUpdate) {
        this.updateForce = this.$props.forceUpdate;
      }

      if (this.$props.visualization) {
        this.communication = this.$props.visualization;
      } else if (!this.updateForce) {
        await this.checkVisibility();
        this.initLog();
      }

      if (this.updateForce) {
        this.initLog();
      }
    });
  },
  methods: {
    onModalHidden() {
      this.isModalVisible = false;
      this.$emit('flow-next');      
    },
    initLog() {
      this.firebase = new Firebase();
    },
    onScroll(el) {
      if (Math.ceil(el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
        this.buttonDisabled = false;
      }
    },
    getCommunicationDescription() { return this.communication ? this.communication.text : ""; },
    getCommunicationTextLink() { return this.communication ? this.communication.textLink : ""; },
    getCommunicationTextButton() { return this.communication ? this.communication.textButton : ""; },
    getUser() { return getNameUser(); },
    onCloseModalHandler() {
      if (this.$refs.commModalRef && this.$refs.commModalRef.$children[0]) {
        this.$refs.commModalRef.$children[0].hide();
      }
    },
    getClasses() {
      return {
        "with-link-image": !!this.communication?.linkImage,
        "without-link-image": !this.communication?.linkImage,
      };
    },
    onRedirect() {
      const pathIfAdmin = (path) => this.$store.getters.isAdmin ? "/admin" + path : path;
      this.onCloseModalHandler();
      if (this.$props.visualization && !this.updateForce) return;
      
      createCommunicationEvent(this.communication.id, "CANCEL", "Clicou em '" + this.getCommunicationTextLink() + "'");
      
      if (this.communication.linkToRedirect?.startsWith('http')) {
        this.handleUrl(this.communication.linkToRedirect);
      } else {
        this.$router.push(pathIfAdmin(this.communication.linkToRedirect));
      }
    },
    handleUrl(linkToRedirect) {
      const internalLinks = ["localhost", "cooperado-hm", "cooperado-dev", "cooperado.unimed"];
      if(internalLinks.some(l => linkToRedirect.includes(l))) {
        this.$router.push(linkToRedirect.split('#')[1]);
      } else {
        window.open(linkToRedirect, "_blank");
      }
    },
    onUpdate() {
      this.onCloseModalHandler();
      if (!this.isCommunicationCurrent || (this.$props.visualization && !this.updateForce)) return;
      
      if (!isAbleRole(RoleList.AUTHORITY_ADMIN)) {
        createCommunicationEvent(this.communication.id, "CONFIRM", "Clicou em '" + this.getCommunicationTextButton() + "'");
        updateCommunication(this.communication.id).then(() => {
          eventBus.$emit("communicationRead", this.communication);
        });
      }
    },
    async checkVisibility() {
      try {
        // 1. Verifica senha de comunicação
        if (this.$store.getters.communicationPassword) {
          this.onModalHidden();
          return;
        } 

        // 2. Verifica Role
        if (isAbleRole(RoleList.AUTHORITY_USER_IS_CUSTOMER)) {
          const responseNotification = await getShowNotification();
          if (responseNotification.showNotification) {
            this.showUpdatedInformations = true;            
            return;
          } 

          // 3. Busca comunicações
          const communications = await getCommunication();
          
          if (communications && communications.length > 0) {
            communications.sort((a, b) => a.apresentationSequence > b.apresentationSequence);
            this.communication = communications[0];
            
            createCommunicationEvent(this.communication.id, "SHOW", "Visualizou o comunicado.");
            if (this.communication.text.length < 450) this.buttonDisabled = false;

            this.isModalVisible = true;

            // Abertura do modal
            this.$nextTick(() => {
              if (this.$refs.commModalRef) {
                // Tenta abrir pelo ID (mais seguro no BootstrapVue)
                this.$bvModal.show(this.modalId);
                
                // Fallback via children se o wrapper CustomModalTemplate esconder o ID
                const modal = this.$refs.commModalRef.$children[0];
                if (modal && typeof modal.show === 'function') {
                  modal.show();
                }
              } else {
                console.error('[Guia Médico] Erro: Referência commModalRef não encontrada');
              }
            });
          } else {
            this.onModalHidden();
          }
        } else {
          this.onModalHidden();
        }
      } catch (error) {
        console.error("[Guia Médico] Erro crítico no checkVisibility:", error);
        this.onModalHidden();
      }
    },
    checkCommunicationCurrent() {
      if (this.communication) {
        const now = new Date();
        this.isCommunicationCurrent = now >= new Date(this.communication.dateStart) && now <= new Date(this.communication.dateEnd); 
      }
    }
  },
};
</script>